import React, { useState, useEffect, useRef } from 'react'
import { AnimatePresence, motion, useMotionValue } from "motion/react";
import { calculateRemValue } from '../../hooks/useDynamicMediaQuery';


const fadeIn = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
	},
	exit: {
		opacity: 0,
	},
};

const Searchbar = () => {
	const [isOpen, setIsOpen] = useState(false);
	const inputRef = useRef();
	const buttonOpacity = useMotionValue(1);

	const handleClick = () => {
		const updatedOpenValue = !isOpen;

		if (updatedOpenValue) {
			buttonOpacity.set(0);
		} else {			
			setTimeout(() => buttonOpacity.set(1), 500);
		}

		setIsOpen(updatedOpenValue);
	};

	useEffect(() => {
		if (inputRef && inputRef.current && isOpen) {
			inputRef.current.focus();
		}

	}, [isOpen])
	const handleSubmit = (e) => {
		e.preventDefault();
		const searchInput = inputRef.current.value;

		if (!searchInput) return;
		
		const searchUrl = `/?s=${searchInput}`;

		// navigate to the new URL
		window.location.href = searchUrl;

		// clear the search bar
		inputRef.current.value = "";
	};

	return (
		<form
			onSubmit={handleSubmit}
			className={`header-search ${isOpen ? "is-open" : ""}`}>
			<span className="header-search__icon--search"></span>
			<AnimatePresence>
				{isOpen && (
					<div className="header-search__container">
						<motion.span {...fadeIn} className="header-search__icon--close" />
						<motion.button type="submit" initial={{ width: 0 }} exit={{ width: 0 }} animate={{ width: calculateRemValue(44) }} className="header-search__submit" onClick={handleSubmit}></motion.button>
						<motion.input
							ref={inputRef}
							initial={{ width: 0 }}
							animate={{
								width: "100%",
							}}
							exit={{ width: 0 }}
							transition={{
								duration: 0.3,
								ease: "easeInOut",
							}}
							type="text"
							name="search query"
							className="header-search__input"
						/>
					</div>
				)}
			</AnimatePresence>
			<motion.button type="reset" className="header-search__toggle" onClick={handleClick}></motion.button>
		</form>
	)
}

export default Searchbar